import { useParams } from "react-router-dom";
import "./style.css"
import { Helmet } from "react-helmet-async";
import { useEffect, useRef, useState } from "react";
import Screen from "../../Layouts/Screen/Screen";
import { Heart, Trash } from "react-feather";
import Spinner, { LoadingThreeCircle } from "../../../global-components/src/components/spinner/spiner";
import { LIMIT_REQUEST_COMMENTS } from "../../../utils/vars";
import { useAuth } from "../../../global-components/src";
import axios from "axios";
import { Post as PostType } from "../../../types";
import UserSearch from "../../Settings/SearchScreen/User/User";
import { PACOCA_API_URL } from "../../../global-components/src/utils/vars";

interface ModalPostLikesProps {
    show: boolean; // Define que posts é um array de Post
    idPostSelected: number | null; // Define que posts é um array de Post
}

const ModalPostLikes: React.FC<ModalPostLikesProps> = ({ show, idPostSelected }) => {
    const { id: postId } = useParams();
    const [likes, setLikes] = useState<any[]>([]);
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPost, setIsLoadingPost] = useState(false);
    const { token } = useAuth();
    const [loading, setLoading] = useState(true);
    const [post, setPost] = useState<PostType>();
    const openModalLikesRef = useRef<HTMLButtonElement | null>(null);
    const closeModalLikesRef = useRef<HTMLButtonElement | null>(null);
    // const [show, setShow] = useState(false);

    useEffect(() => {
        closeModalLikesRef.current?.click();
    }, [location.pathname]); // Executa toda vez que a URL muda

    useEffect(() => {
        if (show){
            loadLikes()
            openModalLikesRef.current?.click()
        }
        else
            closeModalLikesRef.current?.click()
    }, [show])

    useEffect(() => {
        const handleModalClose = () => {
            setLikes([]);
            setIsLoading(false)
            setOffset(0)
            setHasMore(true)
        };
    
        const modalElement = document.getElementById("modal-likes");
        if (modalElement) {
            modalElement.addEventListener("hidden.bs.modal", handleModalClose);
        }
    
        return () => {
            if (modalElement) {
                modalElement.removeEventListener("hidden.bs.modal", handleModalClose);
            }
        };
    }, []);

    const loadLikes = async () => {
        if (isLoading || !hasMore) return;
        
        setLikes([]);
        setIsLoading(true);
        const url = `${PACOCA_API_URL}/posts/likes/${idPostSelected}/?limit=${LIMIT_REQUEST_COMMENTS}&offset=${offset}`;

        try {
            const response = await axios.get(url, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            });

            if (response.data.likes.length < LIMIT_REQUEST_COMMENTS) setHasMore(false);

            setLikes((prevLikes) => [...prevLikes, ...response.data.likes]);
            setOffset((prevOffset) => prevOffset + LIMIT_REQUEST_COMMENTS);
        } catch (error) {
            console.error("Erro ao carregar curtidas:", error);
        } finally {
            setIsLoading(false);
        }
    };


    return (

        <div className="modal fade " id={"modal-likes"} aria-hidden="true">
            <div className="modal-dialog modal-dialog-likes modal-dialog-centered cover-mobile" role="document">
                <div className="modal-content modal-content-likes" id="modal-content-likes">
                    <div className="modal-header modal-header-likes">
                        {/* <h5 className="modal-title">Curtidas</h5> */}
                        <h4 className={`modal-title ml-5`} id="modal-curtida">Curtidas</h4>

                        <button data-bs-dismiss="modal" aria-label="Close" ref={closeModalLikesRef} type="button" className="btn-close"></button>
                    </div>
                    <div className="modal-body modal-body-likes overflow-minus">
                        {isLoading || isLoadingPost ? (
                            <div className="row user-select-none row-empty">
                                <LoadingThreeCircle style={{justifyContent: "center"}}/>
                                {/* <Spinner className="text-primary" size="20" borderWidth="2" /> */}
                            </div>
                        ) : (

                            <>
                                {isLoadingPost ? (
                                    <div className="user-select-none row row-empty-comment">
                                        <span className="span-empty">
                                            <Trash className="icon-empty" />
                                            <h3 className="w-100 text-center">Essa publicação foi apagada</h3>
                                        </span>
                                    </div>
                                ) : !isLoadingPost && likes.length === 0 ? (
                                    <div className="row user-select-none row-empty">
                                        <span className="span-empty">
                                            <Heart className="icon-empty" data-feather="heart" />
                                            <h3 className="w-100 text-center">Seja o primeiro a curtir</h3>
                                        </span>
                                    </div>
                                ) : (
                                    // Renderiza a lista de curtidas normalmente
                                    likes.map((user) => (
                                        <UserSearch clasImgAccount="img-likes" clasNameSearch="name-likes" user={user}/>
                                    ))
                                )}

                            </>
                        )}
                    </div>
                </div>
            </div>

            <button className="d-none" ref={openModalLikesRef} data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target={"#modal-likes"}>a</button>

        </div>


    );
};

export default ModalPostLikes;
